import { render, staticRenderFns } from "./configMarginOne.vue?vue&type=template&id=70d469ac&scoped=true"
import script from "./configMarginOne.vue?vue&type=script&lang=js"
export * from "./configMarginOne.vue?vue&type=script&lang=js"
import style0 from "./configMarginOne.vue?vue&type=style&index=0&id=70d469ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d469ac",
  null
  
)

export default component.exports